class InfiniteScroll {
  constructor() {
    this.container = document.querySelector('#product-grid');
    if (!this.container) return;

    this.nextPageUrl = this.getNextPageUrl();
    if (!this.nextPageUrl) return;

    this.loading = false;

    this.hidePagination();
    this.createSentinel();

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    });

    this.observer.observe(this.sentinel);
  }

  getNextPageUrl() {
    const selectors = [
      'a[rel="next"]',
      'a[aria-label="次のページ"]',
      '.pagination__item-arrow:not([aria-label*="前"])',
      '.pagination__list li:last-child a',
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.href) return el.href;
    }
    return null;
  }

  hidePagination() {
    const pagination = document.querySelector('.pagination');
    if (pagination) pagination.style.display = 'none';
  }

  createSentinel() {
    this.sentinel = document.createElement('div');
    this.sentinel.className = 'infinite-scroll-sentinel';
    this.sentinel.style.cssText = 'width:100%;height:50px;display:block;background:transparent;';
    this.container.after(this.sentinel);
  }

  async onIntersect(entries) {
    if (!entries[0].isIntersecting || this.loading || !this.nextPageUrl) return;

    this.loading = true;
    this.showSpinner();

    try {
      const response = await fetch(this.nextPageUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('#product-grid > *');
      newProducts.forEach(item => this.container.appendChild(item));

      const nextLink = doc.querySelector('a[aria-label="次のページ"]')
        || doc.querySelector('a[rel="next"]');
      this.nextPageUrl = nextLink ? nextLink.href : null;

      if (!this.nextPageUrl) {
        this.observer.disconnect();
        this.sentinel.remove();
      }
    } catch (e) {
      console.error('Infinite scroll error:', e);
    } finally {
      this.loading = false;
      this.hideSpinner();
    }
  }

  showSpinner() {
    if (this.spinner) return;
    this.spinner = document.createElement('div');
    this.spinner.innerHTML = `
      <style>
        @keyframes rotator{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}
        @keyframes dash{0%{stroke-dashoffset:187}50%{stroke-dashoffset:46;transform:rotate(135deg)}100%{stroke-dashoffset:187;transform:rotate(450deg)}}
        .is-svg{animation:rotator 1.4s linear infinite;display:block;margin:2rem auto;}
        .is-circle{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;animation:dash 1.4s ease-in-out infinite;}
      </style>
      <svg class="is-svg" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="is-circle" fill="none" stroke="#333" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>`;
    this.sentinel.before(this.spinner);
  }

  hideSpinner() {
    if (this.spinner) { this.spinner.remove(); this.spinner = null; }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(() => new InfiniteScroll(), 300));
} else {
  setTimeout(() => new InfiniteScroll(), 300);
}
